Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('react');
var WertWidget = require('@wert-io/widget-initializer');
var widgetScSigner = require('@wert-io/widget-sc-signer');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var WertWidget__default = /*#__PURE__*/_interopDefaultLegacy(WertWidget);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var generateListeners = function (_a) {
  var widgetCallback = _a.widgetCallback,
    listeners = _a.listeners;
  return __assign(__assign({}, listeners ? listeners : {}), {
    close: function () {
      widgetCallback && widgetCallback();
      (listeners === null || listeners === void 0 ? void 0 : listeners.close) && listeners.close();
    }
  });
};
var generateSignedData = function (smartContractOptions) {
  if (!smartContractOptions) return {};
  var private_key = smartContractOptions.private_key,
    rest = __rest(smartContractOptions, ["private_key"]);
  return widgetScSigner.signSmartContractData(rest, private_key);
};
var reactiveThemeParameters = ['theme', 'brand_color'];
var updateTheme = function (_a) {
  var widget = _a.widget,
    options = _a.options,
    prevOptions = _a.prevOptions;
  if (!widget) return;
  var changedThemeParameters = reactiveThemeParameters.reduce(function (accum, parameter) {
    var _a;
    var _b;
    if (((_b = prevOptions.current) === null || _b === void 0 ? void 0 : _b[parameter]) !== (options === null || options === void 0 ? void 0 : options[parameter])) {
      switch (parameter) {
        case 'theme':
          return __assign(__assign({}, accum), {
            theme: options === null || options === void 0 ? void 0 : options[parameter]
          });
        default:
          return __assign(__assign({}, accum), (_a = {}, _a[parameter] = options === null || options === void 0 ? void 0 : options[parameter], _a));
      }
    }
    return accum;
  }, {});
  if (Object.keys(changedThemeParameters).length) {
    widget.updateTheme(changedThemeParameters);
  }
};
var updateListeners = function (_a) {
  var _b;
  var widget = _a.widget,
    options = _a.options,
    prevOptions = _a.prevOptions,
    widgetCallback = _a.widgetCallback;
  if (!widget) return;
  if ((_b = prevOptions.current) === null || _b === void 0 ? void 0 : _b.listeners) {
    var newListeners_1 = (options === null || options === void 0 ? void 0 : options.listeners) || {};
    var listenersToRemove = Object.keys(prevOptions.current.listeners).filter(function (key) {
      return !(key in newListeners_1);
    });
    listenersToRemove.length && widget.removeEventListeners(listenersToRemove);
  }
  var listeners = generateListeners({
    listeners: options === null || options === void 0 ? void 0 : options.listeners,
    widgetCallback: widgetCallback
  });
  widget.addEventListeners(listeners);
};
var updateReactiveOptions = function (_a) {
  var widget = _a.widget,
    options = _a.options,
    prevOptions = _a.prevOptions,
    widgetCallback = _a.widgetCallback;
  updateTheme({
    widget: widget,
    options: options,
    prevOptions: prevOptions
  });
  updateListeners({
    widget: widget,
    options: options,
    prevOptions: prevOptions,
    widgetCallback: widgetCallback
  });
  prevOptions.current = options;
};
var useWertWidget = function (reactiveOptions) {
  var prevOptions = react.useRef(reactiveOptions);
  var wertWidget = react.useRef();
  var _a = react.useState(false),
    isWidgetOpen = _a[0],
    setIsWidgetOpen = _a[1];
  react.useEffect(function () {
    updateReactiveOptions({
      widget: wertWidget.current,
      widgetCallback: function () {
        return setIsWidgetOpen(false);
      },
      options: reactiveOptions,
      prevOptions: prevOptions
    });
  }, [reactiveOptions]);
  return {
    open: function (_a) {
      var options = _a.options,
        smartContractOptions = _a.smartContractOptions;
      if (isWidgetOpen) {
        console.error('The Wert widget is already open');
        return;
      }
      wertWidget.current = new WertWidget__default["default"](__assign(__assign(__assign(__assign({}, options), reactiveOptions), {
        listeners: generateListeners({
          listeners: reactiveOptions === null || reactiveOptions === void 0 ? void 0 : reactiveOptions.listeners,
          widgetCallback: function () {
            return setIsWidgetOpen(false);
          }
        })
      }), smartContractOptions ? generateSignedData(smartContractOptions) : {}));
      wertWidget.current.open();
      setIsWidgetOpen(true);
    },
    close: function () {
      var _a;
      if (!isWidgetOpen) {
        console.error('The Wert widget is already closed');
        return;
      }
      (_a = wertWidget.current) === null || _a === void 0 ? void 0 : _a.close();
      setIsWidgetOpen(false);
    },
    isWidgetOpen: isWidgetOpen
  };
};
exports.useWertWidget = useWertWidget;